<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <!-- <div class="gift__note">
            <p>
              As a special thank you gift for a gift of $108 or more we will send you a
              choice of one of the OU’s famous pocket diaries or OU Post-its in addition
              to other members only benefits including:
            </p>
            <ul>
              <li>Exclusive virtual events</li>
              <li>Subscription to award winning Jewish Action magazine</li>
              <li>Discounts on OU Press books</li>
            </ul>
          </div> -->
          <FormSection title="1. Choose Your Membership Level">
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
            <br />
            <div class="frequency">
              <PaymentOptions addMonthly />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="2. Membership Type">
            <FormLabel class="radio-inline">
              <input
                type="radio"
                name="currency"
                id="currency-cad"
                :checked="getValue('custom.membershipType') == 'renewing'"
                @click="setValue('custom.membershipType', 'renewing')"
              />
              I am renewing my OU membership
            </FormLabel>
            <FormLabel class="radio-inline">
              <input
                type="radio"
                name="currency"
                id="currency-cad"
                :checked="getValue('custom.membershipType') == 'new'"
                @click="setValue('custom.membershipType', 'new')"
              />
              I am becoming an OU member
            </FormLabel>
          </FormSection>
          <FormSection title="3. OU Member Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
            </FormRow>
          </FormSection>
          <FormSection title="4. Where should we send your gift">
            <div id="personalInfo">
            <DonorAddress />
            <FormCol field="phone" />
            <br>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>
            </div>
          </FormSection>
          <FormSection title="5. Payment Information" last>
             <FormCol field="card" :showLabel="false" />
          </FormSection>
          <FormSection last>
            <FormRow>
              <input
                type="checkbox"
                id="newsletterSHSH"
                name="newsletterSHSH"
                @click="setValue('custom.newsletterSHSH', $event.target.checked)"
              />
              <FormLabel for="newsletterSHSH">
                Sign me up for the OU's weekly Shabbat Shalom newsletter</FormLabel
              >
            </FormRow>
            <!-- <FormRow>
              <input
                type="checkbox"
                checked
                id="newsletterChizuk"
                name="newsletterChizuk"
                @click="setValue('custom.newsletterChizuk', $event.target.checked)"
              />
              <FormLabel for="newsletterChizuk">
                Sign me up for the Daily Tehillim and Chizuk</FormLabel
              >
            </FormRow> -->
            <FormRow>
              <input
                type="checkbox"
                id="newsletterJa"
                name="newsletterJa"
                @click="setValue('custom.newsletterJa', $event.target.checked)"
              />
              <FormLabel for="newsletterJa">
                Sign me up for Jewish Action’s monthly newsletter</FormLabel
              >
            </FormRow>
            <FormRow>
              <input
                type="checkbox"
                id="planningSpecialist"
                name="planningSpecialist"
                @click="setValue('custom.planningSpecialist', $event.target.checked)"
              />
              <FormLabel for="planningSpecialist">
                Please have the OU’s Legacy Planning Specialist reach out to me</FormLabel
              >
            </FormRow>
            <br />
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit, setValue, getValue } = usePaymentForm();


    const params = queryParams();

if (params.utm_campaign) {
  //@ts-ignore
  if (params.utm_campaign.includes("Telemarketing")) {
    setValue("applications.0.subCampaign", "Telemarketing");
    setValue("custom.Note", "MDSDU2410T");
  }
}

if (params.source) {
  //@ts-ignore
  if (params.source.includes("email")) {
    setValue("applications.0.campaign", "ADM Membership Dues Campaign");
    setValue("applications.0.subCampaign", "Email - Fall");
  }
}

    setValue("custom.membershipType", "new");
    setValue(
      "callback",
      process.env.NODE_ENV != "production"
        ? "https://www.ou.org/wp-json/api/membership/newsletter"
        : "https://www.ou.org/wp-json/api/membership/newsletter"
    );

    watch(
      () => form.value.custom,
      (n, o) => {
        if (JSON.stringify(n) == JSON.stringify(o)) return;
        setValue("signup", Object.values(form.value.custom || {}).length > 0);
      }
    );

    return {
      form,
      setValue,
      getValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right: 5px;
}
::v-deep h2 {
  color: #202964 !important;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep .form-container.ou-donation-form {
  @media only screen and (min-width: 720px) {
        margin: 14px auto 0px;
  }
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="12"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "college student special";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="108"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "most popular choice";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]:checked
  + label[data-amount="12"]:after {
  color: white;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]:not(:checked)
  + label[data-amount="108"] {
  background: #eee7fd;
}

.gift__note {
  padding: 15px;
  margin-bottom: 25px;
  border: 1px solid #d6e9c6;
  border-radius: 4px;
  line-height: 1.4;
  font-size: 14px;
  background-color: #fafafa;
  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    overflow-wrap: break-word;
    margin-top: 10px;
    padding-left: 20px;
    margin-bottom: 0px;
    li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
  }
}

.checktext {
  margin-top: -28px !important;
  line-height: 21px;
  @media only screen and (min-width: 720px) {
    margin-top: -20px !important;
  }
  p {
    margin-top: 11px;
    margin-bottom: 0px;
  }
  .checktext__lg{
    font-size: 20px;
    font-weight: 700;
    padding-bottom: 4px;
    line-height: normal;
    color: #1E53A3;
  }
}
</style>
